import React from 'react';
import {useLocation, useParams} from 'react-router-dom';
// import ErrorBoundary from '../../ErrorBoundary';
import {graphql, useLazyLoadQuery} from 'react-relay/hooks';
import A from './a/A';
import B from './b/B';
import C from './c/C';
import D from './d/D';
import e from '../../../pages/warp/e';
import {ErrorBoundary} from 'react-error-boundary';
import ErrorFallbackHomePage from '../../ErrorFallbackHomePage';
import {DEFAULT_SERVICE_DESCRIPTION_SEPARATOR} from '../../../constants';
import getTagValue from '../../../utilities/get-tag-value';
import getServiceUrl from '../../../utilities/get-service-url';
import EffectRedirect from '../../EffectRedirect';
import {ServiceNotFoundWithShell} from '../../../pages/warp/service-not-found';
import {SeoAlternateHreflang, SeoCanonical} from '../../seo-meta-tags';

const components = {
    'A': A,
    'B': B,
    'C': C,
    'D': D,
    'E': e
};

const Warp = React.memo(() => {
    const {payload} = useParams();
    const data = useLazyLoadQuery(
        graphql`
            query WarpServiceQuery($payload: String) {
                serviceByIdOrSlug(payload: $payload) {
                    id
                    warp
                    slug
                    description
                    nameUk
                    name
                }
            }
        `,
        {payload: decodeURIComponent(payload)}
    );
    // https://reactjs.org/docs/jsx-in-depth.html#choosing-the-type-at-runtime
    const SpecificWarp = components[data.serviceByIdOrSlug.warp] || A;
    const serviceTags = data.serviceByIdOrSlug.description && data.serviceByIdOrSlug.description.split(DEFAULT_SERVICE_DESCRIPTION_SEPARATOR) || [];
    const isNewService = !!getTagValue(serviceTags, 'theme');
    const serviceUrl = getServiceUrl({description: data.serviceByIdOrSlug.description, id: data.serviceByIdOrSlug.id, slug: data.serviceByIdOrSlug.slug, warp: data.serviceByIdOrSlug.warp, location: {search: ''}});
    if (isNewService) {
         return <EffectRedirect to={`${serviceUrl}`} replace/>
    }
    const location = useLocation();
    return (
        <>
            <SeoCanonical {...{urlPath: serviceUrl}}/>
            <SeoAlternateHreflang {...{urlPath: serviceUrl, locationSearch: location.search, en: data.serviceByIdOrSlug.name && data.serviceByIdOrSlug.nameUk}}/>
            <SpecificWarp id={data.serviceByIdOrSlug.id}/>
        </>
    );
});

export default React.memo(() =>
    <ErrorBoundary {...{FallbackComponent: ErrorFallbackHomePage}}>
        <ErrorBoundary {...{FallbackComponent: ServiceNotFoundWithShell('light')}}>
            <React.Suspense fallback={'Loading...'}>
                <Warp/>
            </React.Suspense>
        </ErrorBoundary>
    </ErrorBoundary>
);